import DynamicSubTabSelector from "./DynamicSubTabSelector";

export default DynamicSubTabSelector;
